import { render } from "./Teacher.vue?vue&type=template&id=22ed8fce&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=ts"
export * from "./Teacher.vue?vue&type=script&lang=ts"

import "./Teacher.vue?vue&type=style&index=0&id=22ed8fce&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-22ed8fce"
/* custom blocks */
import block0 from "./Teacher.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script